import React, { Suspense, lazy } from "react";
import { Loader2 } from "lucide-react";

// Mapping for Admin category components from the tab/ directory
const Building = lazy(() => import("./tab/Building"));
const Landscaping = lazy(() => import("./tab/Landscaping"));
const Machinery = lazy(() => import("./tab/Machinery"));
const Other = lazy(() => import("./tab/Other"));
const Room = lazy(() => import("./tab/Room"));

const categoryComponents = {
  Building: Building,
  Landscaping: Landscaping,
  Machinery: Machinery,
  Other: Other,
  Room: Room,
};

const AdminAssetCategoryPage = ({ category, title }) => {
  // Use the provided category or default to Other
  const CategoryComponent = categoryComponents[category] || Other;

  return (
    <div className="flex flex-col h-screen bg-background">
      {/* Header */}
      <div className="border-b bg-card">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-bold tracking-tight">
            {title || category} Assets
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Manage and organize {category.toLowerCase()} assets as Administrator
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto">
        <div className="p-6 overflow-x-hidden">
          <Suspense
            fallback={
              <div className="flex flex-col items-center justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
                <p className="text-muted-foreground">Loading content...</p>
              </div>
            }
          >
            <CategoryComponent category={category} />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default AdminAssetCategoryPage;
